import React from 'react'
import Transition from 'react-prop-transition'
import onClickOutside from "react-onclickoutside"
import './ExpandableCard.scss'

export default class ExpandableCard extends React.Component {
	state = {
		expanded: false,
		initialHeight: null,
    closing: false
	}
	expandCard = () => {
    if(this.props.onStartExpand){
      this.props.onStartExpand()
    }
		const size = this.block.getBoundingClientRect()
		this.setState({
			expanded: true,
			initialHeight: size.height
		})
	}
	collapseCard = () => {
		this.setState({
			expanded: false,
      closing: false
		})
	}
	startCollapse = () => {
    if(this.props.onStartCollapse){
      this.props.onStartCollapse()
    }
    this.setState({
      closing: true
    })
		this.card.getInstance().close()
	}
	render() {
		const { onPrimaryButtonClick, className='', expandedChildren, collapsedChildren, cardClassName='' } = this.props
		return (
			<div
				className={`expandable-card-wrapper ${className}`}
				style={{
					zIndex: this.state.expanded ? 9999 : ''
				}}
      >
				{
          this.state.expanded &&
          <AnimatedCard
            ref={ref => {
							this.card = ref
						}}
            cardClassName={cardClassName}
						onCloseAnimationFinished={this.collapseCard}
            onPrimaryButtonClick={onPrimaryButtonClick}
						initialHeight={this.state.initialHeight}
            onRequestClose={this.startCollapse}
            animated
					>
            {
              expandedChildren({expand: this.expandCard, collapse: this.startCollapse})
            }
          </AnimatedCard>
        }
        {
          collapsedChildren({innerRef: ref => {this.block = ref}, expand: this.expandCard, collapse: this.startCollapse})
        }
			</div>
		)
	}
}

export class AnimatedCard extends React.PureComponent{
  state = {
    visible: false,
    targetHeight: this.props.initialHeight,
    closing: false
  }
  componentDidMount = () => {
    this.calculateTargetHeight()
    this.setVisible(true)
  }
  close = () => {
    this.setState({
      targetHeight: this.props.initialHeight,
      closing: true
    })
  }
  setVisible = visible => {
    this.setState({
      visible
    })
  }
  calculateTargetHeight = () => {
    const card = this.card.getBoundingClientRect()
    this.setState({
      targetHeight: card.height
    })
  }
  handleClickOutside = () => {
    this.props.onRequestClose()
  }
  onPrimaryButtonClick = e => {
    e.stopPropagation()
    this.props.onPrimaryButtonClick(this.props.formDefinitionId)
  }
  render(){
    const { animated, children, cardClassName } = this.props;
    return(
      <Transition props={{height: this.state.targetHeight}} duration={300}>
        {
          props => (
            <div
              ref={ref => { this.card = ref }}
              className={`expandable-card ${cardClassName} ${animated ? this.state.closing ? 'collapse-out' : 'expand-in' : ''}`}
              style={{
                height: this.state.visible ? props.height : '',
                opacity: this.state.visible ? 1 : 0
              }}
            >
              {children}
              {
                this.state.closing &&
                <RestDetector target={this.props.initialHeight} current={props.height} onRest={this.props.onCloseAnimationFinished} />
              }
            </div>
          )
        }
      </Transition>
    )
  }
}
AnimatedCard = onClickOutside(AnimatedCard)

class RestDetector extends React.Component{
  componentWillReceiveProps = nextProps => {
    if(nextProps.current === this.props.target){
      this.props.onRest()
    }
  }
  render(){
    return(
      null
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ExpandableCard/ExpandableCard.js